import ApiRequest from "../utils/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Book {
    getAll = async (q = '', page = 0) => {
        return await ApiRequest.set(`/v1/book/list-book?q=${q}&page=${page}`, "GET");
    }
}